export const packs = [
  {
    packId: 1,
    wday: ['mo', 'tu'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Fire Demon Crown Fragments',
    category: ['artifact', 'crown-artifact'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'fdc-frag', qty: 2, g: 600 }], r: true },
      { l: 2, p: 4.99, items: [{ i: 'fdc-frag', qty: 3, g: 1000 }], r: true },
      { l: 3, p: 9.99, items: [{ i: 'fdc-frag', qty: 5, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'fdc-frag', qty: 11, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'fdc-frag', qty: 15, g: 6000 }] },
      { l: 6, p: 49.99, items: [{ i: 'fdc-frag', qty: 23, g: 10000 }] },
      { l: 7, p: 99.99, items: [{ i: 'fdc-frag', qty: 40, g: 20000 }] }
    ]
  },
  {
    packId: 2,
    wday: ['fr'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Recruitment Speed Up 1h',
    category: ['speed', ' recruit'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'speed-r-1h', qty: 38, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-r-1h', qty: 54, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'speed-r-1h', qty: 94, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-r-1h', qty: 120, g: 3000 }] },
      { l: 5, p: 19.99, items: [{ i: 'speed-r-1h', qty: 140, g: 4000 }] },
      { l: 6, p: 29.99, items: [{ i: 'speed-r-1h', qty: 184, g: 6000 }] },
      { l: 7, p: 49.99, items: [{ i: 'speed-r-1h', qty: 274, g: 10000 }] }
    ]
  },
  {
    packId: 3,
    wday: ['fr'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Speed Up 1h',
    category: ['speed', ' regular'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'speed-1h', qty: 30, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-1h', qty: 45, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'speed-1h', qty: 75, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-1h', qty: 95, g: 3000 }] },
      { l: 5, p: 19.99, items: [{ i: 'speed-1h', qty: 115, g: 4000 }] }
    ]
  },
  {
    packId: 4,
    wday: ['fr'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Beast Skill XP Scroll',
    category: ['beast', ' beast-skill-exp'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'beast-s-exp', qty: 35, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'beast-s-exp', qty: 55, g: 1600 }] },
      { l: 3, p: 14.99, items: [{ i: 'beast-s-exp', qty: 90, g: 3000 }] },
      { l: 4, p: 19.99, items: [{ i: 'beast-s-exp', qty: 100, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'beast-s-exp', qty: 135, g: 6000 }] },
      { l: 6, p: 39.99, items: [{ i: 'beast-s-exp', qty: 160, g: 8000 }] }
    ]
  },
  {
    packId: 5,
    wday: ['fr'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Phoenix Ashes',
    category: ['beast', ' phoenix'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'phoenix', qty: 12, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'phoenix', qty: 20, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'phoenix', qty: 35, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'phoenix', qty: 45, g: 6000 }] }
    ]
  },
  {
    packId: 6,
    wday: ['mo', 'fr', 'we'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Azurite Pack',
    category: ['azurite'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'azurite', qty: 200, g: 800 }], r: true },
      { l: 2, p: 5.99, items: [{ i: 'azurite', qty: 340, g: 1400 }], r: true },
      { l: 3, p: 14.99, items: [{ i: 'azurite', qty: 650, g: 3000 }] },
      { l: 4, p: 29.99, items: [{ i: 'azurite', qty: 1150, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'azurite', qty: 1600, g: 10000 }] }
    ]
  },
  {
    packId: 7,
    wday: ['fr'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Artifact-Exclusive Custom',
    category: ['artifact', ' gold', ' custom'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'art-gold-custom-frag', qty: 1, g: 400 }], r: true },
      { l: 2, p: 4.99, items: [{ i: 'art-gold-custom-frag', qty: 3, g: 1000 }], r: true },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-custom-frag', qty: 4, g: 1400 }] },
      { l: 4, p: 9.99, items: [{ i: 'art-gold-custom-frag', qty: 6, g: 2000 }] },
      { l: 5, p: 19.99, items: [{ i: 'art-gold-custom-frag', qty: 9, g: 4000 }] },
      { l: 6, p: 29.99, items: [{ i: 'art-gold-custom-frag', qty: 13, g: 6000 }] }
    ]
  },
  {
    packId: 8,
    wday: ['fr'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Vip points 1000',
    category: ['vip'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'vip', qty: 11, g: 1000 }], r: true },
      { l: 2, p: 9.99, items: [{ i: 'vip', qty: 17, g: 2000 }] },
      { l: 3, p: 14.99, items: [{ i: 'vip', qty: 22, g: 3000 }] }
    ]
  },
  {
    packId: 9,
    wday: ['th', 'fr'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Azurite Pack (Limited)',
    category: ['azurite'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'azurite', qty: 240, g: 1000 }], r: true },
      { l: 2, p: 9.99, items: [{ i: 'azurite', qty: 450, g: 2000 }], r: true },
      { l: 3, p: 19.99, items: [{ i: 'azurite', qty: 750, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'azurite', qty: 980, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'azurite', qty: 1250, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'azurite', qty: 2200, g: 20000 }] }
    ]
  },
  {
    packId: 10,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Weekly Deal Victory Horn',
    category: ['artifact', ' gold', ' laevateinn'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'laev-frag', qty: 1, g: 400 }] },
      { l: 2, p: 4.99, items: [{ i: 'laev-frag', qty: 2, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'laev-frag', qty: 4, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'laev-frag', qty: 6, g: 3000 }] },
      { l: 5, p: 20.99, items: [{ i: 'laev-frag', qty: 7, g: 4000 }] },
      { l: 6, p: 49.99, items: [{ i: 'laev-frag', qty: 14, g: 10000 }] }
    ]
  },
  {
    packId: 11,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Glimmering Gems Pack',
    category: ['gems'],
    packDet: [
      { l: 1, p: 6.99, items: [{ i: 'gems0', qty: 7, g: 8400 }], r: true },
      { l: 2, p: 9.99, items: [{ i: 'gems0', qty: 10, g: 12000 }] }
    ]
  },
  {
    packId: 12,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Superior Runestone',
    category: ['runestone', 'totem'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'stone-purple', qty: 195, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'stone-purple', qty: 300, g: 1400 }] },
      { l: 3, p: 9.99, items: [{ i: 'stone-purple', qty: 380, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'stone-purple', qty: 650, g: 4000 }] }
    ]
  },
  {
    packId: 13,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Rapid speed',
    category: ['speed', ' 50'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'speed-50p', qty: 8, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-50p', qty: 12, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'speed-50p', qty: 18, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'speed-50p', qty: 25, g: 4000 }] }
    ]
  },
  {
    packId: 14,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Light of Artifacts - Artifact Experience',
    category: ['artifact', 'artifact exp'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-exp-1000', qty: 24, g: 800 }] },
      { l: 2, p: 7.99, items: [{ i: 'art-exp-1000', qty: 40, g: 1600 }] },
      { l: 3, p: 14.99, items: [{ i: 'art-exp-1000', qty: 62, g: 3000 }] },
      { l: 4, p: 29.99, items: [{ i: 'art-exp-1000', qty: 105, g: 6000 }] },
      { l: 5, p: 39.99, items: [{ i: 'art-exp-1000', qty: 125, g: 8000 }] }
    ]
  },
  {
    packId: 15,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Orange fragments',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'art-gold-frag', qty: 2, g: 400 }], r: true },
      { l: 2, p: 3.99, items: [{ i: 'art-gold-frag', qty: 3, g: 800 }], r: true },
      { l: 3, p: 7.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1600 }] },
      { l: 4, p: 19.99, items: [{ i: 'art-gold-frag', qty: 11, g: 4000 }] }
    ]
  },
  {
    packId: 16,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Equipment enhancement - Obsidian',
    category: ['obsidian', ' equipment'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'obsidian', qty: 35, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'obsidian', qty: 50, g: 1400 }] },
      { l: 3, p: 14.99, items: [{ i: 'obsidian', qty: 80, g: 3000 }] },
      { l: 4, p: 29.99, items: [{ i: 'obsidian', qty: 135, g: 6000 }] },
      { l: 5, p: 39.99, items: [{ i: 'obsidian', qty: 170, g: 8000 }] }
    ]
  },
  {
    packId: 17,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Beast Talent - Beast Element',
    category: ['beast', ' beast-element'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'beast-element', qty: 110, g: 1000 }], r: true },
      { l: 2, p: 9.99, items: [{ i: 'beast-element', qty: 190, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-element', qty: 330, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-element', qty: 430, g: 6000 }] }
    ]
  },
  {
    packId: 18,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Azurite Pack',
    category: ['azurite'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'azurite', qty: 190, g: 600 }], r: true },
      { l: 2, p: 4.99, items: [{ i: 'azurite', qty: 300, g: 1000 }], r: true },
      { l: 3, p: 9.99, items: [{ i: 'azurite', qty: 550, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'azurite', qty: 700, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'azurite', qty: 1250, g: 6000 }] }
    ]
  },
  {
    packId: 19,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Speed Up Development Speed 1h',
    category: ['speed', ' regular'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'speed-1h', qty: 32, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-1h', qty: 48, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'speed-1h', qty: 80, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-1h', qty: 100, g: 3000 }] }
    ]
  },
  {
    packId: 20,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Recruit Troops Speed 1h',
    category: ['speed', ' recruit'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'speed-r-1h', qty: 40, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-r-1h', qty: 60, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'speed-r-1h', qty: 100, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-r-1h', qty: 124, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'speed-r-1h', qty: 220, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'speed-r-1h', qty: 364, g: 12000 }] }
    ]
  },
  {
    packId: 21,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Recruit Troops Speed 1h',
    category: ['speed', ' recruit'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'speed-r-1h', qty: 30, g: 400 }] },
      { l: 2, p: 3.99, items: [{ i: 'speed-r-1h', qty: 52, g: 800 }] },
      { l: 3, p: 6.99, items: [{ i: 'speed-r-1h', qty: 96, g: 1400 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-r-1h', qty: 134, g: 3000 }] }
    ]
  },
  {
    packId: 22,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Speed Up Development Speed 1h',
    category: ['speed', ' recruit'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'speed-1h', qty: 25, g: 400 }] },
      { l: 2, p: 3.99, items: [{ i: 'speed-1h', qty: 42, g: 800 }] },
      { l: 3, p: 6.99, items: [{ i: 'speed-1h', qty: 60, g: 1400 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-1h', qty: 105, g: 3000 }] }
    ]
  },
  {
    packId: 23,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Azurite Pack',
    category: ['azurite'],
    packDet: [
      { l: 1, p: 6.99, items: [{ i: 'azurite', qty: 500, g: 1400 }] },
      { l: 2, p: 14.99, items: [{ i: 'azurite', qty: 900, g: 3000 }] },
      { l: 3, p: 39.99, items: [{ i: 'azurite', qty: 1900, g: 8000 }] },
      { l: 4, p: 59.99, items: [{ i: 'azurite', qty: 2300, g: 12000 }] }
    ]
  },
  {
    packId: 24,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Light of Artifacts - Artifact Experience',
    category: ['artifact', 'artifact exp'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'art-exp-1000', qty: 22, g: 600 }] },
      { l: 2, p: 6.99, items: [{ i: 'art-exp-1000', qty: 45, g: 1400 }] },
      { l: 3, p: 14.99, items: [{ i: 'art-exp-1000', qty: 80, g: 3000 }] },
      { l: 4, p: 19.99, items: [{ i: 'art-exp-1000', qty: 90, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-exp-1000', qty: 110, g: 6000 }] }
    ]
  },
  {
    packId: 25,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Beast Evolution - Beast Skill Exp',
    category: ['beast', 'beast-skill-exp'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'beast-s-exp', qty: 45, g: 800 }] },
      { l: 2, p: 8.99, items: [{ i: 'beast-s-exp', qty: 85, g: 1800 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-s-exp', qty: 155, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-s-exp', qty: 180, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'beast-s-exp', qty: 240, g: 10000 }] }
    ]
  },
  {
    packId: 26,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Beast Talent - Beast Element',
    category: ['beast', ' beast-element'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'beast-element', qty: 100, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'beast-element', qty: 155, g: 1400 }] },
      { l: 3, p: 9.99, items: [{ i: 'beast-element', qty: 195, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'beast-element', qty: 335, g: 4000 }] }
    ]
  },
  {
    packId: 27,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Superior Runestone',
    category: ['runestone', 'totem'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'stone-purple', qty: 250, g: 1000 }] },
      { l: 2, p: 6.99, items: [{ i: 'stone-purple', qty: 310, g: 1400 }] },
      { l: 3, p: 9.99, items: [{ i: 'stone-purple', qty: 390, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'stone-purple', qty: 510, g: 3000 }] }
    ]
  },
  {
    packId: 28,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Zodiac Evolution - Birthstone Crystal',
    category: ['birthstone-crystal', 'zodiac'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'crystal-b', qty: 6, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'crystal-b', qty: 10, g: 2000 }] },
      { l: 3, p: 14.99, items: [{ i: 'crystal-b', qty: 16, g: 3000 }] },
      { l: 4, p: 29.99, items: [{ i: 'crystal-b', qty: 26, g: 6000 }] },
      { l: 5, p: 39.99, items: [{ i: 'crystal-b', qty: 30, g: 8000 }] },
      { l: 6, p: 49.99, items: [{ i: 'crystal-b', qty: 33, g: 10000 }] }
    ]
  },
  {
    packId: 29,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'High End Development - Obsidian',
    category: ['obsidian', 'equipment'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'obsidian', qty: 100, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'obsidian', qty: 180, g: 2000 }] },
      { l: 3, p: 14.99, items: [{ i: 'obsidian', qty: 240, g: 3000 }] }
    ]
  },
  {
    packId: 30,
    wday: ['sa'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Enchantment crystal',
    category: ['titan', ' crystal'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'titan-crystal', qty: 22, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'titan-crystal', qty: 35, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'titan-crystal', qty: 62, g: 2000 }] },
      { l: 4, p: 15.99, items: [{ i: 'titan-crystal', qty: 82, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'titan-crystal', qty: 143, g: 6000 }] },
      { l: 6, p: 49.99, items: [{ i: 'titan-crystal', qty: 220, g: 10000 }] }
    ]
  },
  {
    packId: 31,
    wday: ['sa'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Heavenly spear',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-gold-frag', qty: 4, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1200 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-frag', qty: 6, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 10, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 17, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 28, g: 12000 }] }
    ]
  },
  {
    packId: 32,
    wday: ['sa'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Mjolnir',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-gold-frag', qty: 4, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1200 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-frag', qty: 6, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 10, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 17, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 28, g: 12000 }] }
    ]
  },
  {
    packId: 33,
    wday: ['sa'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Light of Artifacts - Artifact Experience',
    category: ['artifact', 'artifact exp'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'art-exp-1000', qty: 22, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'art-exp-1000', qty: 38, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'art-exp-1000', qty: 66, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'art-exp-1000', qty: 86, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'art-exp-1000', qty: 120, g: 10000 }] }
    ]
  },
  {
    packId: 34,
    wday: ['sa'],
    tab: 'daily',
    loc: 'limited',
    desc: 'March speeed',
    category: ['speed', ' 50'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'speed-50p', qty: 5, g: 400 }] },
      { l: 2, p: 3.99, items: [{ i: 'speed-50p', qty: 9, g: 800 }] },
      { l: 3, p: 5.99, items: [{ i: 'speed-50p', qty: 13, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-50p', qty: 20, g: 3000 }] }
    ]
  },
  {
    packId: 35,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Azurite Pack',
    category: ['azurite'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'azurite', qty: 190, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'azurite', qty: 340, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'azurite', qty: 592, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'azurite', qty: 768, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'azurite', qty: 1024, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'azurite', qty: 1650, g: 20000 }] },
      { l: 7, p: 99.99, items: [{ i: 'azurite', qty: 1650, g: 20000 }] }
    ]
  },
  {
    packId: 36,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Military logistics - Speed',
    category: ['speed', ' healing'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'speed-h-1h', qty: 24, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'speed-h-1h', qty: 48, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'speed-h-1h', qty: 72, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'speed-h-1h', qty: 96, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'speed-h-1h', qty: 144, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'speed-h-1h', qty: 264, g: 20000 }] }
    ]
  },
  {
    packId: 37,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Troop recruitment exclusive',
    category: ['speed', ' recruit'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'speed-r-1h', qty: 24, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'speed-r-1h', qty: 48, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'speed-r-1h', qty: 72, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'speed-r-1h', qty: 96, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'speed-r-1h', qty: 120, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'speed-r-1h', qty: 240, g: 20000 }] }
    ]
  },
  {
    packId: 38,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Guardian force - Dust',
    category: ['angel dust'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'dust-1k', qty: 50, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'dust-1k', qty: 70, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'dust-1k', qty: 120, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'dust-1k', qty: 160, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'dust-1k', qty: 230, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'dust-1k', qty: 370, g: 20000 }] }
    ]
  },
  {
    packId: 39,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Conjure pack - Gold Coins',
    category: ['coins', ' conjure'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'art-gold-coin', qty: 25, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'art-gold-coin', qty: 45, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'art-gold-coin', qty: 70, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'art-gold-coin', qty: 90, g: 6000 }] }
    ]
  },
  {
    packId: 40,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Artifact Fortification - Artifac Exp',
    category: ['artifact', ' artifact exp'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'art-exp-1000', qty: 15, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'art-exp-1000', qty: 24, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'art-exp-1000', qty: 42, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'art-exp-1000', qty: 55, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'art-exp-1000', qty: 80, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'art-exp-1000', qty: 120, g: 20000 }] }
    ]
  },
  {
    packId: 41,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Poseidon Trident',
    category: ['artifact', ' gold', ' trident'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'trident-frag', qty: 1, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'trident-frag', qty: 2, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'trident-frag', qty: 4, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'trident-frag', qty: 5, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'trident-frag', qty: 7, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'trident-frag', qty: 9, g: 20000 }] }
    ]
  },
  {
    packId: 42,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Leavateinn',
    category: ['artifact', ' gold', ' leavateinn'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'laev-frag', qty: 1, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'laev-frag', qty: 2, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'laev-frag', qty: 4, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'laev-frag', qty: 5, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'laev-frag', qty: 7, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'laev-frag', qty: 9, g: 20000 }] }
    ]
  },
  {
    packId: 43,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Orange Fragments',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 6.99, items: [{ i: 'art-gold-frag', qty: 2, g: 1400 }] },
      { l: 2, p: 19.99, items: [{ i: 'art-gold-frag', qty: 5, g: 4000 }] },
      { l: 3, p: 29.99, items: [{ i: 'art-gold-frag', qty: 6, g: 6000 }] },
      { l: 4, p: 59.99, items: [{ i: 'art-gold-frag', qty: 9, g: 12000 }] },
      { l: 5, p: 99.99, items: [{ i: 'art-gold-frag', qty: 12, g: 20000 }] }
    ]
  },
  {
    packId: 44,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Titan Raw Energy',
    category: ['titan', ' raw'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'titan-raw-1k', qty: 8, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'titan-raw-1k', qty: 14.6, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'titan-raw-1k', qty: 27, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'titan-raw-1k', qty: 36, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'titan-raw-1k', qty: 56, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'titan-raw-1k', qty: 100, g: 20000 }] },
      { l: 7, p: 99.99, items: [{ i: 'titan-raw-1k', qty: 100, g: 20000 }] }
    ]
  },
  {
    packId: 45,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Titan Protholith fragment',
    category: ['titan', ' protholith'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'titan-prot', qty: 25, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'titan-prot', qty: 45, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'titan-prot', qty: 80, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'titan-prot', qty: 105, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'titan-prot', qty: 165, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'titan-prot', qty: 300, g: 20000 }] },
      { l: 7, p: 99.99, items: [{ i: 'titan-prot', qty: 300, g: 20000 }] }
    ]
  },
  {
    packId: 46,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Titan Enchantement ',
    category: ['titan', ' crystal'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'titan-crystal', qty: 32, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'titan-crystal', qty: 60, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'titan-crystal', qty: 100, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'titan-crystal', qty: 135, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'titan-crystal', qty: 210, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'titan-crystal', qty: 390, g: 20000 }] },
      { l: 7, p: 99.99, items: [{ i: 'titan-crystal', qty: 390, g: 20000 }] }
    ]
  },
  {
    packId: 47,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Orange totem skill',
    category: ['totem', ' tattoo', ' orange'],
    packDet: [
      { l: 1, p: 9.99, items: [{ i: 'tattoo-gold', qty: 6, g: 2000 }] },
      { l: 2, p: 19.99, items: [{ i: 'tattoo-gold', qty: 10, g: 4000 }] },
      { l: 3, p: 29.99, items: [{ i: 'tattoo-gold', qty: 14, g: 6000 }] },
      { l: 4, p: 49.99, items: [{ i: 'tattoo-gold', qty: 22, g: 10000 }] },
      { l: 5, p: 99.99, items: [{ i: 'tattoo-gold', qty: 40, g: 20000 }] }
    ]
  },
  {
    packId: 48,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Purple totem skill',
    category: ['totem', ' tattoo', ' purple'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'tattoo-purple', qty: 25, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'tattoo-purple', qty: 45, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'tattoo-purple', qty: 80, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'tattoo-purple', qty: 110, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'tattoo-purple', qty: 160, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'tattoo-purple', qty: 250, g: 20000 }] }
    ]
  },
  {
    packId: 49,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Superior Runestone',
    category: ['runestone', 'totem'],
    packDet: [
      { l: 1, p: 4.9, items: [{ i: 'stone-purple', qty: 180, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'stone-purple', qty: 300, g: 2000 }] },
      { l: 3, p: 19.9, items: [{ i: 'stone-purple', qty: 520, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'stone-purple', qty: 700, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'stone-purple', qty: 950, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'stone-purple', qty: 1500, g: 20000 }] }
    ]
  },
  {
    packId: 50,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Polycrystalline',
    category: ['zodiac', ' polycrystalline'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'zodiac-poly', qty: 12, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'zodiac-poly', qty: 21, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'zodiac-poly', qty: 34, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'zodiac-poly', qty: 47, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'zodiac-poly', qty: 72, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'zodiac-poly', qty: 140, g: 20000 }] }
    ]
  },
  {
    packId: 51,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Northern palace Starlight',
    category: ['zodiac', ' starlight'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'zodiac-star', qty: 20, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'zodiac-star', qty: 30, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'zodiac-star', qty: 53, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'zodiac-star', qty: 86, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'zodiac-star', qty: 120, g: 6000 }] },
      { l: 6, p: 49.99, items: [{ i: 'zodiac-star', qty: 195, g: 10000 }] },
      { l: 7, p: 99.99, items: [{ i: 'zodiac-star', qty: 360, g: 20000 }] }
    ]
  },
  {
    packId: 52,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Beast fortification - Beast skill xp',
    category: ['beast', 'beast-skill-exp'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'beast-s-exp', qty: 25, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'beast-s-exp', qty: 45, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-s-exp', qty: 75, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-s-exp', qty: 90, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'beast-s-exp', qty: 130, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'beast-s-exp', qty: 220, g: 20000 }] }
    ]
  },
  {
    packId: 53,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Beast grown - Beast xp',
    category: ['beast', ' beast exp'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'beast-exp', qty: 4800, g: 800 }] },
      { l: 2, p: 8.99, items: [{ i: 'beast-exp', qty: 10000, g: 1800 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-exp', qty: 20000, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-exp', qty: 24000, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'beast-exp', qty: 34000, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'beast-exp', qty: 60000, g: 20000 }] }
    ]
  },
  {
    packId: 54,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Beast Talent - Beast Element',
    category: ['beast', ' beast-element'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'beast-element', qty: 80, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'beast-element', qty: 145, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-element', qty: 255, g: 4000 }] },
      { l: 4, p: 49.99, items: [{ i: 'beast-element', qty: 360, g: 10000 }] },
      { l: 5, p: 99.99, items: [{ i: 'beast-element', qty: 580, g: 20000 }] }
    ]
  },
  {
    packId: 55,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Fire Elf - Phoenix Ashes',
    category: ['beast', ' phoenix'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'phoenix', qty: 10, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'phoenix', qty: 18, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'phoenix', qty: 33, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'phoenix', qty: 42, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'phoenix', qty: 80, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'phoenix', qty: 110, g: 20000 }] }
    ]
  },
  {
    packId: 56,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Equipment materials',
    category: ['equipment', ' chest', ' blue'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'mat-chest-b', qty: 10, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'mat-chest-b', qty: 18, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'mat-chest-b', qty: 30, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'mat-chest-b', qty: 36, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'mat-chest-b', qty: 42, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'mat-chest-b', qty: 60, g: 20000 }] }
    ]
  },
  {
    packId: 57,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Obsidian steel',
    category: ['equipment', ' obsidian'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'obsidian', qty: 25, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'obsidian', qty: 44, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'obsidian', qty: 70, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'obsidian', qty: 90, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'obsidian', qty: 130, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'obsidian', qty: 210, g: 20000 }] },
      { l: 7, p: 99.99, items: [{ i: 'obsidian', qty: 210, g: 20000 }] }
    ]
  },
  {
    packId: 58,
    wday: ['su', 'th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Raw energy',
    category: ['titan', 'raw'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'titan-raw-1k', qty: 5.6, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'titan-raw-1k', qty: 9.6, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'titan-raw-1k', qty: 16, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'titan-raw-1k', qty: 22, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'titan-raw-1k', qty: 40, g: 6000 }] },
      { l: 6, p: 49.99, items: [{ i: 'titan-raw-1k', qty: 60, g: 10000 }] }
    ]
  },
  {
    packId: 59,
    wday: ['su'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Brionac',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-gold-frag', qty: 4, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1200 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-frag', qty: 6, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 10, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 17, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 28, g: 12000 }] }
    ]
  },
  {
    packId: 60,
    wday: ['su'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Poseidon trident',
    category: ['artifact', ' gold', ' trident'],
    packDet: [
      { l: 1, p: 5.99, items: [{ i: 'trident-frag', qty: 2, g: 1400 }] },
      { l: 2, p: 14.99, items: [{ i: 'trident-frag', qty: 4, g: 3000 }] },
      { l: 3, p: 29.99, items: [{ i: 'trident-frag', qty: 7, g: 6000 }] },
      { l: 4, p: 39.99, items: [{ i: 'trident-frag', qty: 8, g: 8000 }] },
      { l: 5, p: 59.99, items: [{ i: 'trident-frag', qty: 10, g: 12000 }] },
      { l: 6, p: 99.99, items: [{ i: 'trident-frag', qty: 15, g: 20000 }] },
      { l: 7, p: 99.99, items: [{ i: 'trident-frag', qty: 15, g: 20000 }] }
    ]
  },
  {
    packId: 61,
    wday: ['su'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Power recovery',
    category: ['speed', ' healing'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'speed-h-1h', qty: 25, g: 400 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-h-1h', qty: 60, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'speed-h-1h', qty: 100, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'speed-h-1h', qty: 130, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'speed-h-1h', qty: 240, g: 6000 }] }
    ]
  },
  {
    packId: 62,
    wday: ['mo'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Apollo Bow',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-gold-frag', qty: 4, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1200 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-frag', qty: 6, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 10, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 17, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 28, g: 12000 }] }
    ]
  },
  {
    packId: 63,
    wday: ['mo', 'th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Beast Talent - Beast Element',
    category: ['beast', ' beast-element'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'beast-element', qty: 100, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'beast-element', qty: 180, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-element', qty: 320, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-element', qty: 400, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'beast-element', qty: 560, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'beast-element', qty: 900, g: 20000 }] }
    ]
  },
  {
    packId: 64,
    wday: ['mo', 'we'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Orange Totem Skill',
    category: ['totem', ' tattoo', ' orange'],
    packDet: [
      { l: 1, p: 6.99, items: [{ i: 'tattoo-gold', qty: 5, g: 1400 }] },
      { l: 2, p: 9.99, items: [{ i: 'tattoo-gold', qty: 7, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'tattoo-gold', qty: 11, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'tattoo-gold', qty: 15, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'tattoo-gold', qty: 23, g: 10000 }] }
    ]
  },
  {
    packId: 65,
    wday: ['mo', 'th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Titan Protholith fragment',
    category: ['titan', ' protholith'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'titan-prot', qty: 22, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'titan-prot', qty: 36, g: 1400 }] },
      { l: 3, p: 14.99, items: [{ i: 'titan-prot', qty: 68, g: 3000 }] },
      { l: 4, p: 19.99, items: [{ i: 'titan-prot', qty: 84, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'titan-prot', qty: 115, g: 6000 }] },
      { l: 6, p: 49.99, items: [{ i: 'titan-prot', qty: 175, g: 10000 }] }
    ]
  },
  {
    packId: 66,
    wday: ['mo', 'th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Purple Totem Skill',
    category: ['totem', ' tattoo', ' purple'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'tattoo-purple', qty: 25, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'tattoo-purple', qty: 36, g: 1400 }] },
      { l: 3, p: 9.99, items: [{ i: 'tattoo-purple', qty: 45, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'tattoo-purple', qty: 80, g: 4000 }] }
    ]
  },
  {
    packId: 67,
    wday: ['tu'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Northern palace Polycrystalline',
    category: ['zodiac', ' polycrystalline'],
    packDet: [
      { l: 1, p: 5.99, items: [{ i: 'zodiac-poly', qty: 16, g: 1200 }] },
      { l: 2, p: 9.99, items: [{ i: 'zodiac-poly', qty: 24, g: 2000 }] },
      { l: 3, p: 15.99, items: [{ i: 'zodiac-poly', qty: 32, g: 3000 }] },
      { l: 4, p: 19.99, items: [{ i: 'zodiac-poly', qty: 37, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'zodiac-poly', qty: 48, g: 6000 }] }
    ]
  },
  {
    packId: 68,
    wday: ['tu'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Zodiac Evolution - Birthstone Crystal',
    category: ['birthstone-crystal', 'zodiac'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'crystal-b', qty: 6, g: 800 }] },
      { l: 2, p: 7.99, items: [{ i: 'crystal-b', qty: 11, g: 1600 }] },
      { l: 3, p: 14.99, items: [{ i: 'crystal-b', qty: 18, g: 3000 }] },
      { l: 4, p: 19.99, items: [{ i: 'crystal-b', qty: 23, g: 4000 }] }
    ]
  },
  {
    packId: 69,
    wday: ['tu', 'th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Superior Runestone',
    category: ['runestone', 'totem'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'stone-purple', qty: 165, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'stone-purple', qty: 255, g: 1400 }] },
      { l: 3, p: 9.99, items: [{ i: 'stone-purple', qty: 320, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'stone-purple', qty: 550, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'stone-purple', qty: 750, g: 6000 }] }
    ]
  },
  {
    packId: 70,
    wday: ['tu'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Athena Aegis',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'art-gold-frag', qty: 2, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'art-gold-frag', qty: 3, g: 1000 }] },
      { l: 3, p: 5.99, items: [{ i: 'art-gold-frag', qty: 4, g: 1400 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 8, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 15, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 27, g: 12000 }] }
    ]
  },
  {
    packId: 71,
    wday: ['tu'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Victory horn',
    category: ['artifact', ' gold', ' leavateinn'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'art-gold-frag', qty: 1, g: 600 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 2, g: 1400 }] },
      { l: 3, p: 14.99, items: [{ i: 'art-gold-frag', qty: 4, g: 3000 }] },
      { l: 4, p: 19.99, items: [{ i: 'art-gold-frag', qty: 5, g: 4000 }] },
      { l: 5, p: 39.99, items: [{ i: 'art-gold-frag', qty: 8, g: 8000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 10, g: 12000 }] },
      { l: 7, p: 99.99, items: [{ i: 'art-gold-frag', qty: 15, g: 20000 }] },
      { l: 8, p: 99.99, items: [{ i: 'art-gold-frag', qty: 15, g: 20000 }] }
    ]
  },
  {
    packId: 72,
    wday: ['tu'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Titan crystal',
    category: ['colossus', ' crystal'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'crystal-colossus', qty: 240, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'crystal-colossus', qty: 420, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'crystal-colossus', qty: 740, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'crystal-colossus', qty: 880, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'crystal-colossus', qty: 1200, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'crystal-colossus', qty: 2000, g: 20000 }] }
    ]
  },
  {
    packId: 73,
    wday: ['we'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Thunderbolt crown',
    category: ['artifact', 'crown-artifact'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'tb-frag', qty: 2, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'tb-frag', qty: 3, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'tb-frag', qty: 6, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'tb-frag', qty: 11, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'tb-frag', qty: 15, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'tb-frag', qty: 27, g: 12000 }] },
      { l: 7, p: 59.99, items: [{ i: 'tb-frag', qty: 27, g: 12000 }] }
    ]
  },
  {
    packId: 74,
    wday: ['we'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Golden armor',
    category: ['artifact', ' gold'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-gold-frag', qty: 4, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1200 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-frag', qty: 6, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 10, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 17, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 28, g: 12000 }] }
    ]
  },
  {
    packId: 75,
    wday: ['we.th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Equipment materials',
    category: ['equipment', ' chest', ' blue'],
    packDet: [
      { l: 1, p: 6.99, items: [{ i: 'mat-chest-b', qty: 25, g: 1400 }] },
      { l: 2, p: 14.99, items: [{ i: 'mat-chest-b', qty: 52, g: 3000 }] },
      { l: 3, p: 19.99, items: [{ i: 'mat-chest-b', qty: 62, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'mat-chest-b', qty: 85, g: 6000 }] }
    ]
  },
  {
    packId: 76,
    wday: ['we', 'th'],
    tab: 'biweekly',
    loc: 'limited',
    desc: 'Recruitment Speed Up 1h',
    category: ['speed', ' recruit'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'speed-r-1h', qty: 30, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'speed-r-1h', qty: 60, g: 1000 }] },
      { l: 3, p: 8.99, items: [{ i: 'speed-r-1h', qty: 90, g: 1800 }] },
      { l: 4, p: 15.99, items: [{ i: 'speed-r-1h', qty: 120, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'speed-r-1h', qty: 160, g: 6000 }] },
      { l: 6, p: 49.99, items: [{ i: 'speed-r-1h', qty: 260, g: 10000 }] },
      { l: 7, p: 99.99, items: [{ i: 'speed-r-1h', qty: 450, g: 20000 }] }
    ]
  },
  {
    packId: 77,
    wday: ['th'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Equipment enhancement - Obsidian',
    category: ['equipment', ' obsidian'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'obsidian', qty: 30, g: 800 }] },
      { l: 2, p: 10.99, items: [{ i: 'obsidian', qty: 60, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'obsidian', qty: 105, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'obsidian', qty: 130, g: 6000 }] },
      { l: 5, p: 39.99, items: [{ i: 'obsidian', qty: 150, g: 8000 }] },
      { l: 6, p: 49.99, items: [{ i: 'obsidian', qty: 160, g: 10000 }] }
    ]
  },
  {
    packId: 78,
    wday: ['th'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Northern palace Starlight',
    category: ['zodiac', ' starlight'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'zodiac-star', qty: 7500, g: 400 }] },
      { l: 2, p: 3.99, items: [{ i: 'zodiac-star', qty: 13500, g: 800 }] },
      { l: 3, p: 6.99, items: [{ i: 'zodiac-star', qty: 21000, g: 1400 }] },
      { l: 4, p: 9.99, items: [{ i: 'zodiac-star', qty: 27500, g: 2000 }] },
      { l: 5, p: 14.99, items: [{ i: 'zodiac-star', qty: 36000, g: 3000 }] },
      { l: 6, p: 29.99, items: [{ i: 'zodiac-star', qty: 65000, g: 6000 }] }
    ]
  },
  {
    packId: 79,
    wday: ['th'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Articact exclusive custom',
    category: ['artifact', ' gold', ' custom'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'art-gold-custom-frag', qty: 1, g: 400 }] },
      { l: 2, p: 4.99, items: [{ i: 'art-gold-custom-frag', qty: 3, g: 1000 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-custom-frag', qty: 4, g: 1400 }] },
      { l: 4, p: 9.99, items: [{ i: 'art-gold-custom-frag', qty: 6, g: 2000 }] },
      { l: 5, p: 19.99, items: [{ i: 'art-gold-custom-frag', qty: 9, g: 4000 }] }
    ]
  },
  {
    packId: 80,
    wday: ['th'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Lucky specials - Beast element',
    category: ['beast', ' beast-element'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'beast-element', qty: 100, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'beast-element', qty: 180, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-element', qty: 320, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-element', qty: 400, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'beast-element', qty: 560, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'beast-element', qty: 900, g: 20000 }] }
    ]
  },
  {
    packId: 81,
    wday: ['week'],
    tab: 'weekly',
    loc: 'limited',
    desc: 'Victory Horn',
    category: ['artifact', 'gold', 'leavateinn'],
    packDet: [
      { l: 1, p: 1.99, items: [{ i: 'laev-frag', qty: 1, g: 400 }] },
      { l: 2, p: 4.99, items: [{ i: 'laev-frag', qty: 2, g: 1000 }] },
      { l: 3, p: 10.99, items: [{ i: 'laev-frag', qty: 4, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'laev-frag', qty: 6, g: 3000 }] },
      { l: 5, p: 19.99, items: [{ i: 'laev-frag', qty: 7, g: 4000 }] },
      { l: 6, p: 49.99, items: [{ i: 'laev-frag', qty: 14, g: 10000 }] }
    ]
  },
  {
    packId: 82,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Starlight Stone',
    category: ['zodiac', 'starlight'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'zodiac-star', qty: 12000, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'zodiac-star', qty: 18000, g: 1000 }] },
      { l: 3, p: 10.99, items: [{ i: 'zodiac-star', qty: 31000, g: 2000 }] },
      { l: 4, p: 14.99, items: [{ i: 'zodiac-star', qty: 40000, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'zodiac-star', qty: 70000, g: 6000 }] }
    ]
  },
  {
    packId: 83,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Polycrystalline',
    category: ['zodiac', 'polycrystalline'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'zodiac-poly', qty: 12, g: 800 }] },
      { l: 2, p: 6.99, items: [{ i: 'zodiac-poly', qty: 19, g: 1400 }] },
      { l: 3, p: 10.99, items: [{ i: 'zodiac-poly', qty: 25, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'zodiac-poly', qty: 42, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'zodiac-poly', qty: 55, g: 6000 }] }
    ]
  },
  {
    packId: 84,
    wday: ['month'],
    tab: 'monthly',
    loc: 'limited',
    desc: 'Fire Elf - Phoenix Ashes',
    category: ['beast', 'phoenix'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'phoenix', qty: 16, g: 1000 }] },
      { l: 2, p: 9.99, items: [{ i: 'phoenix', qty: 27, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'phoenix', qty: 45, g: 4000 }] }
    ]
  },
  {
    packId: 85,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Ancient relic',
    category: ['ancient-relic'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'ancient-relic', qty: 16, g: 1000 }] },
      { l: 2, p: 10.99, items: [{ i: 'ancient-relic', qty: 28, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'ancient-relic', qty: 48, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'ancient-relic', qty: 60, g: 6000 }] }
    ]
  },
  {
    packId: 86,
    wday: ['week'],
    tab: 'biweekly',
    loc: 'regular',
    desc: 'Titan cristal (colossus)',
    category: ['colossus', 'crystal'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'crystal-colossus', qty: 160, g: 100 }] },
      { l: 2, p: 10.99, items: [{ i: 'crystal-colossus', qty: 290, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'crystal-colossus', qty: 490, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'crystal-colossus', qty: 610, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'crystal-colossus', qty: 850, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'crystal-colossus', qty: 1350, g: 20000 }] }
    ]
  },
  {
    packId: 87,
    wday: ['mo'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Beast Talent - Beast Element',
    category: ['beast', 'beast-element'],
    packDet: [
      { l: 1, p: 4.99, items: [{ i: 'beast-element', qty: 100, g: 1000 }] },
      { l: 2, p: 10.99, items: [{ i: 'beast-element', qty: 180, g: 2000 }] },
      { l: 3, p: 19.99, items: [{ i: 'beast-element', qty: 320, g: 4000 }] },
      { l: 4, p: 29.99, items: [{ i: 'beast-element', qty: 400, g: 6000 }] },
      { l: 5, p: 49.99, items: [{ i: 'beast-element', qty: 560, g: 10000 }] },
      { l: 6, p: 99.99, items: [{ i: 'beast-element', qty: 900, g: 20000 }] }
    ]
  },
  {
    packId: 88,
    wday: ['th'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Ice Crown Fragment',
    category: ['ice-frag'],
    packDet: [
      { l: 1, p: 2.99, items: [{ i: 'Ice-frag', qty: 2, g: 600 }] },
      { l: 2, p: 4.99, items: [{ i: 'Ice-frag', qty: 3, g: 1000 }] },
      { l: 3, p: 9.99, items: [{ i: 'Ice-frag', qty: 6, g: 2000 }] },
      { l: 4, p: 19.99, items: [{ i: 'Ice-frag', qty: 11, g: 4000 }] },
      { l: 5, p: 29.99, items: [{ i: 'Ice-frag', qty: 15, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'Ice-frag', qty: 22, g: 12000 }] },
      { l: 7, p: 59.99, items: [{ i: 'Ice-frag', qty: 22, g: 12000 }] }
    ]
  },
  {
    packId: 89,
    wday: ['we'],
    tab: 'daily',
    loc: 'limited',
    desc: 'Caledfwich',
    category: ['artifcat', 'gold'],
    packDet: [
      { l: 1, p: 3.99, items: [{ i: 'art-gold-frag', qty: 4, g: 800 }] },
      { l: 2, p: 5.99, items: [{ i: 'art-gold-frag', qty: 5, g: 1200 }] },
      { l: 3, p: 6.99, items: [{ i: 'art-gold-frag', qty: 6, g: 1600 }] },
      { l: 4, p: 14.99, items: [{ i: 'art-gold-frag', qty: 10, g: 3000 }] },
      { l: 5, p: 29.99, items: [{ i: 'art-gold-frag', qty: 17, g: 6000 }] },
      { l: 6, p: 59.99, items: [{ i: 'art-gold-frag', qty: 28, g: 12000 }] }
    ]
  }
]

export const weekdayDet = {
  0: { day: 'all', desc: 'All' },
  1: { day: 'mo', desc: 'Monday' },
  2: { day: 'tu', desc: 'Tuesday' },
  3: { day: 'we', desc: 'Wednesday' },
  4: { day: 'th', desc: 'Thursday' },
  5: { day: 'fr', desc: 'Friday' },
  6: { day: 'sa', desc: 'Saturday' },
  7: { day: 'su', desc: 'Sunday' },
  8: { day: 'week', desc: 'Weekly' },
  9: { day: 'month', desc: 'Monthly' }
}

export const weekdayConf = {
  mo: { day: 'mo', desc: 'Monday' },
  tu: { day: 'tu', desc: 'Tuesday' },
  we: { day: 'we', desc: 'Wednesday' },
  th: { day: 'th', desc: 'Thursday' },
  fr: { day: 'fr', desc: 'Friday' },
  sa: { day: 'sa', desc: 'Saturday' },
  su: { day: 'su', desc: 'Sunday' },
  week: { day: 'week', desc: 'Weekly' },
  month: { day: 'month', desc: 'Monthly' }
}

/*
  Cuatro claves se usan en packs y no tenian entrada aca, asi que salian crudas en
  la tabla de /packs/ —'speed-h-1h', 'dust-1k'— en cuanto el dato empezo a
  publicarse en el HTML.

  El nombre de cada una no se invento: lo dicen dos fuentes que coinciden. El pack
  que las contiene ya las nombra ("Military logistics - Speed", "Guardian force -
  Dust", "Titan Raw Energy", "Ice Crown Fragment"), y tres de las cuatro tienen aqui
  mismo una entrada gemela sin usar cuya clave es la misma sin el sufijo de tamaño
  ('speed-h', 'dust', 'titan-raw'). Se conserva el texto exacto de esas entradas,
  incluida 'Guardian force', que es como estaba escrito.

  Quedan cinco entradas que no usa ningun pack: art-exp-500, emblem,
  art-force-gold-frag, lord-exp-1k y speed-25p. No se tocan: pueden ser de packs
  retirados o de packs por venir.
*/
export const itemList = [
  { key: 'ancient-relic', desc: 'Ancient Relic' },
  { key: 'speed-h-1h', desc: 'Healing Speed Up 1h' },
  { key: 'dust-1k', desc: 'Guardian force' },
  { key: 'titan-raw-1k', desc: 'Titan Raw Energy' },
  { key: 'Ice-frag', desc: 'Ice Crown Fragment' },
  { key: 'art-exp-1000', desc: 'Artifact Experience 1k' },
  { key: 'art-exp-500', desc: 'Artifact Experience 500' },
  { key: 'art-gold-coin', desc: 'Artifact Gold Coins' },
  { key: 'azurite', desc: 'Azurite' },
  { key: 'beast-element', desc: 'Beast Element' },
  { key: 'beast-exp', desc: 'Beast Experience' },
  { key: 'beast-s-exp', desc: 'Beast Skill XP Scroll' },
  { key: 'crystal-b', desc: 'Birthstone Crystal' },
  { key: 'emblem', desc: 'Emblem Shard' },
  { key: 'titan-crystal', desc: 'Enchantment crystal' },
  { key: 'fdc-frag', desc: 'Fire Demon Crown Frag' },
  { key: 'art-force-gold-frag', desc: 'Force Artifact Fragment' },
  { key: 'gems0', desc: 'Gems' },
  { key: 'art-gold-frag', desc: 'Gold Artifact Fragment' },
  { key: 'art-gold-coin', desc: 'Gold Coin' },
  { key: 'art-gold-custom-frag', desc: 'Gold Custom Artifact Fragment' },
  { key: 'tattoo-gold', desc: 'Gold Psionic Tattoo' },
  { key: 'dust', desc: 'Guardian force' },
  { key: 'speed-h', desc: 'Healing Speed Up 1h' },
  { key: 'laev-frag', desc: 'Laevateinn Fragment' },
  { key: 'lord-exp-1k', desc: 'Lord Experience 1k' },
  { key: 'speed-25p', desc: 'March Speed Up 25%' },
  { key: 'speed-50p', desc: 'March Speed Up 50%' },
  { key: 'mat-chest-b', desc: 'Material Chest Blue' },
  { key: 'obsidian', desc: 'Obsidian' },
  { key: 'phoenix', desc: 'Phoenix Ashes' },
  { key: 'zodiac-poly', desc: 'Polycrystalline' },
  { key: 'trident-frag', desc: 'Poseidon Trident Fragment' },
  { key: 'tattoo-purple', desc: 'Purple Psionic Tattoo' },
  { key: 'speed-r-1h', desc: 'Recruitment Speed Up 1h' },
  { key: 'speed-1h', desc: 'Speed Up 1h' },
  { key: 'zodiac-star', desc: 'Starlight Experience' },
  { key: 'stone-purple', desc: 'Superior Runestone' },
  { key: 'tb-frag', desc: 'Thunderbolt crown fragment' },
  { key: 'crystal-colossus', desc: 'Titan Crystal' },
  { key: 'titan-prot', desc: 'Titan Protholith fragment' },
  { key: 'titan-raw', desc: 'Titan Raw Energy' },
  { key: 'vip', desc: 'VIP points' }
]
